
import axios from "axios";

export interface CepResponse {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string;
  uf: string;
  ibge: string;
  gia: string;
  ddd: string;
  siafi: string;
  erro?: boolean;
}

export async function buscarCEP(cep: string): Promise<CepResponse> {
  try {
    // Remove non-numeric characters
    const cepNumerico = cep.replace(/\D/g, '');
    
    if (cepNumerico.length !== 8) {
      throw new Error("CEP deve conter 8 dígitos");
    }
    
    const resposta = await axios.get<CepResponse>(`https://viacep.com.br/ws/${cepNumerico}/json/`);
    
    if (resposta.data.erro) {
      throw new Error("CEP não encontrado");
    }
    
    return resposta.data;
  } catch (erro) {
    console.error("Erro ao buscar o CEP:", erro);
    throw erro;
  }
}

export const calcularFrete = (cep: string, items: CartItem[]): ShippingOption[] => {
  // In a real application, this would call an actual shipping API
  // For this demo, we'll calculate based on the CEP first digit and cart total
  
  const cepDigit = cep.replace(/\D/g, '')[0];
  const totalItems = items.reduce((sum, item) => sum + (item.quantity || 1), 0);
  const totalValue = items.reduce(
    (sum, item) => sum + ((item.discountedPrice || item.price) * (item.quantity || 1)), 
    0
  );
  
  // Base shipping rates vary by region (first digit of CEP)
  const regionMultiplier = parseInt(cepDigit) > 5 ? 1.2 : 1;
  
  return [
    {
      id: 'standard',
      name: 'Entrega Padrão',
      price: Math.round(10 + (totalValue * 0.05) * regionMultiplier),
      estimatedDelivery: '5-8 dias úteis'
    },
    {
      id: 'express',
      name: 'Entrega Expressa',
      price: Math.round(20 + (totalValue * 0.1) * regionMultiplier),
      estimatedDelivery: '2-3 dias úteis'
    },
    {
      id: 'pickup',
      name: 'Retirada na Loja',
      price: 0,
      estimatedDelivery: 'Em até 1 dia útil'
    }
  ];
};

export interface ShippingOption {
  id: string;
  name: string;
  price: number;
  estimatedDelivery: string;
}

export interface CartItem {
  id: string;
  title: string;
  price: number;
  discountedPrice?: number;
  imageUrl: string;
  quantity: number;
  size?: string;
  color?: string;
  printOption?: string;
}
